import React from 'react';
import { Link } from 'react-router';
import { Row, Col, Image } from 'react-bootstrap';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import editcampaign from '../../images/edit-campaign.png';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';

export default class ReferenceLayerSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    this.sidebarFuzzyFilterFactory = fuzzyFilterFactory();
    this.updateFilterValue = this.updateFilterValue.bind(this);
  }

  componentDidMount() {
    this.props.getReferenceLayers();
  }

  updateFilterValue(filterValue) {
    this.setState({ filterValue: filterValue || '' });
  }

  moveFocusToHeading = item => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const referenceLayerId = this.props.params.referenceLayerId || 'new';

    const LineItem = props => {
      const referenceLayer = props.item;
      return (
        <Row
          key={referenceLayer.id}
          className={`sidebar-list-item`}
          onClick={e => this.moveFocusToHeading(referenceLayer)}
        >
          <Link to={`/reference-layers/${referenceLayer.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${referenceLayerId ===
                referenceLayer.id.toString() && 'active'}`}
            >
              <p title={referenceLayer.label} className="single-line">
                <strong>{referenceLayer.label}</strong>
              </p>
            </Col>
          </Link>
          <Link to={`/reference-layers/${referenceLayer.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit Industry" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing reference layer {this.state.currentItemName}
            </h3>
            <h1>Reference Layers</h1>
          </Col>

          <Col sm={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.sidebarFuzzyFilterFactory}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              component={LineItem}
              items={this.props.referenceLayers}
              fuzzyFilterFactory={this.sidebarFuzzyFilterFactory}
              pluralName="reference layers"
              keys={['id', 'label']}
            />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebars/ReferenceLayersSidebar.js